import './resources.css'

const SixthWebinarResource = () => {
    return (
        <ul className= 'additional-resources' >
            <h3> Additional Resources: </h3>
            <li onClick = {() => window.open("https://www.cdc.gov/healthypets/pets/farm-animals.html")}> CDC Healthy Pets, Healthy People – Farm Animals Page </li>
            <li onClick={() => window.open("https://www.cdc.gov/onehealth/basics/zoonotic-diseases.html")}> CDC One Health – Zoonotic Diseases Page </li>
            <li onClick={() => window.open("https://www.oie.int/en/what-we-do/animal-health-and-welfare/animal-diseases/")}> OIE Animal Diseases Page </li>
            {/*Nested List */}
            <li onClick={()=> window.open("https://www.cfsph.iastate.edu/zoonoses/")}> CFSPH Zoonotic Diseases Resources </li>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/infection-control/routes/#zoonotic")}> CFSPH Disease Exposure Routes – Zoonotic Transmission Page  </li>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/diseaseinfo/")}> CFSPH Animal Diseases Page </li>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/biosecurity-resource/agritourism/")}> CFSPH Agritourism Biosecurity Tips </li>
        </ul>
    )
}

export default SixthWebinarResource;